// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"79eb9582","703":"e67928eb","787":"35b5e3e2"}[chunkId] + ".chunk.js";
};